/*───────────────────────────────────────────────────────────────
  icons.helper.ts  ·  clave‑producto  →  ruta del SVG
───────────────────────────────────────────────────────────────*/
const ICON_PATH = 'assets/icons/gantt-icons/';

/**
 * Mapa de las claves de producto tal como llegan del backend
 * a su icono correspondiente.  Si un producto no está presente,
 * la UI deberá mostrar un placeholder genérico.
 */
export const PRODUCT_ICON_RAW: Record<string, string> = {
  /*────────────── Vehículo de sustitución ──────────────*/
  'Basic Replacement Vehicle': ICON_PATH + 'Type=Vehiculo_sustitucion.svg',

  /*────────────── Wash – Completo ──────────────*/
  'Cafler Complete Atv Wash': ICON_PATH + 'Type=Lavados.svg',
  'Cafler Complete Car Wash': ICON_PATH + 'Type=Lavados.svg',
  'Cafler Complete Light Van Wash': ICON_PATH + 'Type=Lavados.svg',
  'Cafler Complete Minivan Wash': ICON_PATH + 'Type=Lavados.svg',
  'Cafler Complete Van Wash': ICON_PATH + 'Type=Lavados.svg',
  'Complete atv wash': ICON_PATH + 'Type=Lavados.svg',
  'Complete car wash': ICON_PATH + 'Type=Lavados.svg',
  'Complete light van wash': ICON_PATH + 'Type=Lavados.svg',
  'Complete minivan wash': ICON_PATH + 'Type=Lavados.svg',
  'Complete van wash': ICON_PATH + 'Type=Lavados.svg',

  /*────────────── Wash – Exterior ──────────────*/
  'Cafler Exterior Atv Wash': ICON_PATH + 'Type=exteriorespecializado.svg',
  'Cafler Exterior Car Wash': ICON_PATH + 'Type=exteriorespecializado.svg',
  'Cafler Exterior Light Van Wash':
    ICON_PATH + 'Type=exteriorespecializado.svg',
  'Cafler Exterior Minivan Wash': ICON_PATH + 'Type=exteriorespecializado.svg',
  'Cafler Exterior Van Wash': ICON_PATH + 'Type=exteriorespecializado.svg',
  'Express Exterior Atv Wash': ICON_PATH + 'Type=exteriorespecializado.svg',
  'Express Exterior Car Wash': ICON_PATH + 'Type=exteriorespecializado.svg',
  'Express Exterior Light Van Wash':
    ICON_PATH + 'Type=exteriorespecializado.svg',
  'Express Exterior Minivan Wash': ICON_PATH + 'Type=exteriorespecializado.svg',
  'Express Exterior Van Wash': ICON_PATH + 'Type=exteriorespecializado.svg',
  'Exterior Atv Wash': ICON_PATH + 'Type=exteriorespecializado.svg',
  'Exterior Car Wash': ICON_PATH + 'Type=exteriorespecializado.svg',
  'Exterior Light Van Wash': ICON_PATH + 'Type=exteriorespecializado.svg',
  'Exterior Minivan Wash': ICON_PATH + 'Type=exteriorespecializado.svg',
  'Exterior Van Wash': ICON_PATH + 'Type=exteriorespecializado.svg',

  /*────────────── Wash – Interior ──────────────*/
  'Cafler Interior Atv Wash': ICON_PATH + 'Type=aspiradorinteriormano.svg',
  'Cafler Interior Car Wash': ICON_PATH + 'Type=aspiradorinteriormano.svg',
  'Cafler Interior Light Van Wash':
    ICON_PATH + 'Type=aspiradorinteriormano.svg',
  'Cafler Interior Minivan Wash': ICON_PATH + 'Type=aspiradorinteriormano.svg',
  'Cafler Interior Van Wash': ICON_PATH + 'Type=aspiradorinteriormano.svg',
  'Express Interior Atv Wash': ICON_PATH + 'Type=aspiradorinteriormano.svg',
  'Express Interior Car Wash': ICON_PATH + 'Type=aspiradorinteriormano.svg',
  'Express Interior Light Van Wash':
    ICON_PATH + 'Type=aspiradorinteriormano.svg',
  'Express Interior Minivan Wash': ICON_PATH + 'Type=aspiradorinteriormano.svg',
  'Express Interior Van Wash': ICON_PATH + 'Type=aspiradorinteriormano.svg',
  'Interior atv wash': ICON_PATH + 'Type=aspiradorinteriormano.svg',
  'Interior car wash': ICON_PATH + 'Type=aspiradorinteriormano.svg',
  'Interior light van wash': ICON_PATH + 'Type=aspiradorinteriormano.svg',
  'Interior minivan wash': ICON_PATH + 'Type=aspiradorinteriormano.svg',
  'Interior van wash': ICON_PATH + 'Type=aspiradorinteriormano.svg',

  /*────────────── Wash – Express completo ──────*/
  'Express Complete Atv Wash': ICON_PATH + 'Type=Lavados.svg',
  'Express Complete Car Wash': ICON_PATH + 'Type=Lavados.svg',
  'Express Complete Light Van Wash': ICON_PATH + 'Type=Lavados.svg',
  'Express Complete Minivan Wash': ICON_PATH + 'Type=Lavados.svg',
  'Express Complete Van Wash': ICON_PATH + 'Type=Lavados.svg',

  /*────────────── Tunnel wash ──────────────*/
  'Tunnel Complete Car Wash':
    ICON_PATH + 'Type=Lavados en centros especializados.svg',
  'Tunnel Exterior Car Wash':
    ICON_PATH + 'Type=Lavados en centros especializados.svg',
  'Tunnel Interior Car Wash':
    ICON_PATH + 'Type=Lavados en centros especializados.svg',
  'Tunnel Motorbike Wash':
    ICON_PATH + 'Type=Lavados en centros especializados.svg',
  'Tunnel wash': ICON_PATH + 'Type=Lavados en centros especializados.svg',

  /*────────────── Cafler Fresh ──────────────*/
  'Cafler Fresh ATV Topping': ICON_PATH + 'Type=Cafler Fresh.svg',
  'Cafler Fresh Car Topping': ICON_PATH + 'Type=Cafler Fresh.svg',
  'Cafler Fresh Lightvan Topping': ICON_PATH + 'Type=Cafler Fresh.svg',
  'Cafler Fresh Minivan Topping': ICON_PATH + 'Type=Cafler Fresh.svg',
  'Cafler Fresh Truck Topping': ICON_PATH + 'Type=Cafler Fresh.svg',
  'Cafler Fresh Van Topping': ICON_PATH + 'Type=Cafler Fresh.svg',

  /*────────────── Ready / Fine‑tunning ────────*/
  'Cafler Ready': ICON_PATH + 'Type=Puesta a punto.svg',

  /*────────────── Maintenance ──────────────*/
  'Car Basic Maintenance': ICON_PATH + 'Type=Packs mantenimiento.svg',
  'Car Medium Maintenance': ICON_PATH + 'Type=Packs mantenimiento.svg',
  'Car Complete Maintenance': ICON_PATH + 'Type=Packs mantenimiento.svg',
  'Motorbike Basic Maintenance': ICON_PATH + 'Type=Motocicleta.svg',
  'Motorbike Complete Maintenance': ICON_PATH + 'Type=Motocicleta.svg',

  /*────────────── MOT / ITV ──────────────*/
  'Car MOT': ICON_PATH + 'Type=ITV.svg',
  'Diesel Car MOT': ICON_PATH + 'Type=ITV.svg',
  'Petrol Car MOT': ICON_PATH + 'Type=ITV.svg',
  'Gas Car MOT': ICON_PATH + 'Type=ITV.svg',
  'Hybrid Car MOT': ICON_PATH + 'Type=ITV.svg',
  'Electric Car MOT': ICON_PATH + 'Type=ITV.svg',
  'Petrol Car MO': ICON_PATH + 'Type=ITV.svg',

  'Diesel Van MOT': ICON_PATH + 'Type=ITV.svg',
  'Electric Van MOT': ICON_PATH + 'Type=ITV.svg',
  'Gas Van MOT': ICON_PATH + 'Type=ITV.svg',
  'Hybrid Van MOT': ICON_PATH + 'Type=ITV.svg',

  'Motorbike MOT': ICON_PATH + 'Type=MOT.svg',
  'Motorbike +125 MOT': ICON_PATH + 'Type=MOT.svg',
  'Motorbike -125 MOT': ICON_PATH + 'Type=MOT.svg',
  'Electric Motorbike +125 MOT': ICON_PATH + 'Type=MOT.svg',
  'Electric Motorbike -125 MOT': ICON_PATH + 'Type=MOT.svg',

  'MOT Homologation': ICON_PATH + 'Type=ITV Homologacion.svg',

  /*────────────── Pre‑MOT ──────────────*/
  'Pre-MOT': ICON_PATH + 'Type=Pre_ITV.svg',
  'Pre-MOT + Diesel Car MOT': ICON_PATH + 'Type=Pre_ITV.svg',
  'Pre-Mot + Diesel Van MOT': ICON_PATH + 'Type=Pre_ITV.svg',
  'Pre-MOT + Electric Car MOT': ICON_PATH + 'Type=Pre_ITV.svg',
  'Pre-MOT + Electric Motorbike +125 MOT': ICON_PATH + 'Type=Pre_ITV.svg',
  'Pre-MOT + Electric Motorbike -125 MOT': ICON_PATH + 'Type=Pre_ITV.svg',
  'Pre-Mot + Electric Van MOT': ICON_PATH + 'Type=Pre_ITV.svg',
  'Pre-Mot + Gas Van MOT': ICON_PATH + 'Type=Pre_ITV.svg',
  'Pre-MOT + Hybrid Car MOT': ICON_PATH + 'Type=Pre_ITV.svg',
  'Pre-Mot + Hybrid Van MOT': ICON_PATH + 'Type=Pre_ITV.svg',
  'Pre-MOT + Motorbike +125 MOT': ICON_PATH + 'Type=Pre_ITV.svg',
  'Pre-MOT + Motorbike -125 MOT': ICON_PATH + 'Type=Pre_ITV.svg',
  'Pre-MOT + Petrol Car MOT': ICON_PATH + 'Type=Pre_ITV.svg',

  /*────────────── Refueling ──────────────*/
  Refueling: ICON_PATH + 'Type=Repostaje.svg',
  'Refueling Atv': ICON_PATH + 'Type=Repostaje.svg',
  'Refueling Light Van': ICON_PATH + 'Type=Repostaje.svg',
  'Refueling Minivan': ICON_PATH + 'Type=Repostaje.svg',
  'Refueling motorbike': ICON_PATH + 'Type=Repostaje.svg',
  'Refueling scooter': ICON_PATH + 'Type=Repostaje.svg',
  'Refueling Van': ICON_PATH + 'Type=Repostaje.svg',

  /*────────────── Otros toppings / extras ──────────────*/
  'Checklist topping':
    ICON_PATH + 'Type=Lista de comprobacion del estado del vehiculo.svg',
  'Headlight Polishing': ICON_PATH + 'Type=Pulido de faros.svg',
  'Insurance Topping': ICON_PATH + 'Type=Seguros.svg',
  'Integral Washing': ICON_PATH + 'Type=Integral.svg',
  'Tire Check': ICON_PATH + 'Type=Neumaticos.svg',
  Tyres: ICON_PATH + 'Type=Neumaticos.svg',
  'Upholstery 5 Seats': ICON_PATH + 'Type=Tapicerias.svg',

  /*────────────── Trámites / miscelánea ──────────────*/
  'Ownership change': ICON_PATH + 'Type=Cambio de nombre.svg',
  'Medium Long Distance': ICON_PATH + 'Type=Media_y_larga_distancia.svg',

  /*────────────── Logística / movimientos ──────────────*/
  Collect: ICON_PATH + 'Type=initial_trans.svg',
  Return: ICON_PATH + 'Type=initial_trans.svg',
  Transfer: ICON_PATH + 'Type=Transfer.svg',
  'Transfer and Replacement Vehicle': ICON_PATH + 'Type=Transfer.svg',
  'Valet Train Station': ICON_PATH + 'Type=Valet.svg',
  'Battery change': ICON_PATH + 'Type=Transfer.svg',

  /*────────────── Infraestructura ──────────────*/
  Parking: ICON_PATH + 'Type=Parking.svg',
  'Vehicle Storage': ICON_PATH + 'Type=Parking.svg',
  'Tow truck': ICON_PATH + 'Type=Grua.svg',

  /*────────────── Servicio mecánico ──────────────*/
  'Workshop at home': ICON_PATH + 'Type=Diagnostico.svg',
  'Motorbike wash': ICON_PATH + 'Type=Motocicleta.svg', // lavado específico moto
};

export function normalizeKey(key: string): string {
  return key.trim().toLowerCase().replace(/\s+/g, '');
}

const PRODUCT_ICON_NORMALIZED = Object.fromEntries(
  Object.entries(PRODUCT_ICON_RAW).map(([k, v]) => [normalizeKey(k), v])
);

/*───────────────────────────────────────────────────────────────
  Helper
───────────────────────────────────────────────────────────────*/
/** Devuelve la ruta del SVG o `undefined` si no hay icono asignado */
export function getProductIcon(productKey: string): string | undefined {
  return PRODUCT_ICON_NORMALIZED[normalizeKey(productKey)];
}
